<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-btn x-large class="myYellow2 ml-8" to="/">
          <v-icon left>mdi-chevron-left</v-icon> HOME
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="ma-8 pb-2">
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>

      <v-card class="ma-6 pa-6">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Name"
              v-model="customerForm.name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              :items="tableList"
              v-model="customerForm.table_id"
              label="Table"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Age"
              v-model="customerForm.age"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Email"
              v-model="customerForm.email"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="ma-6 pa-6 d-flex justify-space-between">
        <v-btn text class="myGreen--text" to="/">
          <v-icon left>mdi-chevron-left</v-icon> Back
        </v-btn>
        <v-btn
          class="myGreen white--text"
          @click="ADD_CUSTOMER_DATA({ ...customerForm })"
        >
          Next <v-icon right>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { axios } from "../api";

export default {
  data: () => ({
    customerForm: {
      name: "",
      email: "",
      age: "",
      table_id: "",
      phoneNumber: "",
      job: "",
      domicile: "",
    },
    items: [
      {
        text: "Form",
        disabled: false,
        href: "/neworder",
      },
      {
        text: "Menu",
        disabled: true,
        href: "/newmenu",
      },
      {
        text: "Payment Method",
        disabled: true,
        href: "/newcart",
      },
      {
        text: "Done",
        disabled: true,
        href: "/",
      },
    ],
    tableList: [],
  }),
  methods: {
    ...mapActions(["ADD_CUSTOMER_DATA"]),
    getTable() {
      axios
        .get("/allTable")
        .then((res) => {
          this.tableList = res.data;
          //   console.log(res.data);
        })
        .catch((err) => console.log(err));
    },
  },
  created() {
    this.getTable();
  },
};
</script>
